import { createAction } from 'redux-actions';

export const updateResult = createAction('@@result/UPDATE_RESULT');